import { authenticatedFetch } from './base'

/**
 * Get a list of jurisdictions stored in the system
 *
 * @returns {*} - response containing a list of jurisdictions
 */
export const fetchJurisdictions = () => {
	return authenticatedFetch(`/api/jurisdiction`, { method: 'get' })
		.then(function(response) {
			if (response.status === 200) {
				return response.json()
			}
		})
		.then(function(jurisdiction) {
			return jurisdiction
		})
}
